import { z } from "zod";
import superjson from "superjson";
import { PushPlatformArrayValues } from "../../helpers/schema";

export const schema = z.object({
  fcmToken: z.string(),
  platform: z.enum(PushPlatformArrayValues).default("android"),
  previousIdentity: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
  id?: number;
};

export const postRegisterPush = async (
  body: InputType,
  init?: RequestInit
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/push/register`, {
    method: "POST",
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};